import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { TimestampCreator, Icons } from '@leverege/api-attributes'
import { ValueCard } from '~/views'

export default class TimestampViewer extends React.Component {

  static TYPE = TimestampCreator.typeName();

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    name : PropTypes.string
  }

  render() {
    const { attribute : attr, name, onClick, editable, value } = this.props
    if ( attr == null ) {
      return <div />
    }

    let val = null // '---'
    if ( value ) {
      let date = new Date( value )
      if ( isNaN( date.getTime() ) ) {
        date = null
        if ( typeof value === 'string' ) {
          const pn = parseInt( value )
          if ( !isNaN( pn ) ) {
            if ( pn.toString().length == value.length ) {
              // unix time
              date = new Date( pn )
            } 
          } 
        }
      }

      if ( date ) {
        const m = moment( date )
        val = `${m.format( 'L' )} ${m.format( 'LTS' )}`
      }
    }
   
    const icon = Icons.getIcon( attr )
    return (
      <ValueCard editable={editable} name={name || attr.name} value={val} icon={icon} onClick={onClick} />
    )
  }
}
